import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import cn from 'classnames';

import File from 'components/File';
import styles from './page-editor.module.sass';
import { OverlayLoader } from 'components/Loader';
import { getErrorMessage, isValidImageType } from '@core';
import Card from 'components/Card';
import { getBanner, saveBanner } from 'core/services/komagebi/banner';
import Switch from 'components/Switch';

const schema = yup.object().shape({
  image: yup
    .mixed()
    .required('ველი სავალდებულოა')
    .test('is-valid-image-type', 'სავალდებულოა', value => {
      return isValidImageType(value);
    }),
  enabled: yup.boolean().required(),
});

const BannerEditor = () => {
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm<{ enabled: boolean; image: any }>({ resolver: yupResolver(schema) });
  const [isAdding, setIsAdding] = React.useState(false);

  const [imageControlValue, setImageControlValue] = React.useState();
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      handleImageChange(value.image);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleImageChange = (value: any) => {
    if (value?.[0]?.name) {
      const currentFile = value?.[0];
      if (currentFile) {
        setImageControlValue(URL.createObjectURL(currentFile));
      }
    } else if (typeof value === 'string') {
      setImageControlValue(value);
    }
  };

  const onSubmit = () => {
    void handleSubmit(
      data => {
        setIsAdding(true);
        let requestData = {
          ...data,
        };
        if (data.image[0]) {
          requestData = {
            ...data,
            image: data.image[0],
          }; 
        }

        saveBanner(requestData)
          .then(() => {
            toast.success('წარმატებით განახლდა');
          })
          .catch(() => {
            toast.error('დაფისქირდა შეცდომა');
          })
          .finally(() => {
            setIsAdding(false);
          });
      },
      (errors, event) => {
        console.log(errors, event, 'validation errors');
      },
    )();
  };

  useEffect(() => {
    void getBanner().then(response => {
      reset({
        image: response.data?.photo,
        enabled: response.data?.enabled ?? false,
      });
    });
  }, [reset]);

  const enabled = getValues('enabled') as boolean;

  const setEnabled = (value: boolean) => {
    setValue('enabled', value, { shouldValidate: true });
  };

  return (
    <>
      {isAdding && <OverlayLoader />}
      <>
        <Card
          className={cn(styles.card)}
          head={<Switch className={styles.switch} value={enabled ?? false} onChange={() => setEnabled(!enabled)} />}
          title="ბანერი"
          classTitle="title-green"
        >
          <div>
            <File
              error={getErrorMessage(errors, 'image')}
              className={styles.field}
              name="image"
              title="ფოტოს ატვირთვა"
              type="image"
              label="ფოტო"
              value={imageControlValue}
              register={register}
            />
          </div>

          <div className={cn('panel', styles.panel)}>
            <div className={styles.info}></div>
            <div className={styles.btns}>
              <button onClick={onSubmit} className={cn('button', styles.button)}>
                შენახვა
              </button>
            </div>
          </div>
        </Card>
      </>
    </>
  );
};

export default BannerEditor;
